const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export {
  isSafari, // eslint-disable-line
};
